import FormGradeModeSelect from './FormGradeModeSelect'
export default {
  extends: FormGradeModeSelect,
  computed: {
    mergedConfig () {
      return {
        options: [],
        ...this.config,
        multiple: true,
        searchable: true,
      }
    },
  },
}
